export default "__VITE_ASSET__Dm$0Oytw__"